import { apiFetch } from '../apiFetch'

export const getQueue = async (id) => {
  return await apiFetch({
    path: `/queue/${id}`
  })
}

export const putPlayerInQueue = async (payload) => {
  return await apiFetch({
    method: 'PUT',
    path: `/queue/${payload.id}/players`,
    payload
  })
}

export const putAnswerInQueue = async (payload) => {
  return await apiFetch({
    method: 'PUT',
    path: `/queue/${payload.id}`,
    payload
  })
}
